/**
 * @class CopyButton
 * @extends HTMLElement
 *
 * Custom element that copies a URL to the clipboard when clicked.
 *
 * Reads the target URL from `data-url`. Falls back to
 * `window.location.href` if the attribute is absent.
 */
class CopyButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('keydown', this.#onKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('keydown', this.#onKeydown);
  }

  get url() {
    return this.dataset.url || window.location.href;
  }

  #onClick = () => {
    this.#copyToClipboard(this.url).then(() => {
      this.#showConfirmation();
    });
  };

  #onKeydown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.#onClick();
    }
  }

  async #copyToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(text);
    }
  }

  #showConfirmation() {
    this.classList.add('is-copied');

    clearTimeout(this.confirmationTimeout);

    this.confirmationTimeout = setTimeout(() => {
      this.classList.remove('is-copied');
    }, 2000);
  }
}

customElements.define('copy-button', CopyButton);
